import { type ModelMetadataKpiFormula } from "../explore-budgets/client-setting/types";

import { GeneralInsightsGraph } from "./general-insights/general-insights-graph";
import { KpiBreakdowns } from "./kpi-breakdowns";
import { type ChannelInsightsColumn } from "./model-insights-content";

interface Props {
  selectedKpi: ModelMetadataKpiFormula;
  columns: ChannelInsightsColumn[];
  costCurvesAllTimeData: any;
  costCurvesAllTimeByQuantileData: any;
  costCurvesLoading: boolean;
  historicalContributionsData: Record<string, { spend: number }[]>;
  weeklySpendsByChannel: Record<string, number[]>;
}

export const ChannelInsights = ({
  selectedKpi,
  columns,
  costCurvesAllTimeData,
  costCurvesAllTimeByQuantileData,
  costCurvesLoading,
  historicalContributionsData,
  weeklySpendsByChannel,
}: Props) => (
  <>
    <KpiBreakdowns
      isLoading={costCurvesLoading}
      columns={columns}
      selectedKpi={selectedKpi}
      costCurvesAllTimeData={costCurvesAllTimeData}
      costCurvesAllTimeByQuantileData={costCurvesAllTimeByQuantileData}
      historicalContributionsData={historicalContributionsData}
      weeklySpendsByChannel={weeklySpendsByChannel}
    />
    <GeneralInsightsGraph
      isLoading={costCurvesLoading}
      columns={columns}
      selectedKpi={selectedKpi}
      historicalContributionsData={historicalContributionsData}
    />
  </>
);
